import { createBrowserHistory, createHashHistory } from 'history'
// console.log(location.pathname)
// export default createBrowserHistory({
// 	basename: "/build/"
// })

export default createHashHistory()
